export default "__VITE_ASSET__BjRkc9Yh__"